<template>
<Transition name="banner-slide-fade">
    <MainBannerContent
        :lg="lg"
        :sm="sm"
        :isPortal="isPortal"
        v-if="appStore.mainBanner.show" />
</Transition>
</template>
<script setup>
import { useAppStore } from '@/store/app'
const appStore = useAppStore()

defineProps({
    lg: {
        type: Boolean,
        default: false
    },
    sm: {
      type: Boolean,
      default: false
    },
    isPortal: {
        type: Boolean,
        default: false
    }
})

</script>

<style scoped>
.banner-slide-fade-enter-from,
.banner-slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.banner-slide-fade-enter-active,
.banner-slide-fade-leave-active {
  transition: opacity 200ms ease, transform 200ms ease;
}
</style>